import { render, staticRenderFns } from "./PostSalesPackTab.vue?vue&type=template&id=c3578df8&"
import script from "./PostSalesPackTab.vue?vue&type=script&lang=ts&"
export * from "./PostSalesPackTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports